import React from 'react';
import FixedView from '../FixedView';
import moment from 'moment';
// import Calender from './calender';
import { checkTranslation, getObject, translate } from '../../utils/useful';
import TableViewer from '../TableViewer';


export default class CalendarWeekDaySelector extends React.Component {
    constructor(props) {
        super(props)
        this.firstView = React.createRef();
        this.firstCurrentNode = React.createRef();
        this.yearCurrentNode = React.createRef();
        this.yearCurrentNode = React.createRef();

        this.state = {
            // calender: new Calender(),
            // activeDay: null,
            // key: 'TEpyxZL1neC2JBZViuDaJ'
        }
    }

    componentDidMount() {
        this.setState({ data: this.props.data })
    }
    showMonthList = () => {
        console.log("DDD")
        this.firstView.showView()
    }
    showYearList = () => {
        this.yearView.showView()
    }

    selectDay = (day) => {
        // let newDate = moment.utc();
        // newDate.set('year', year);
        // newDate.set('month', month - 1);
        // newDate.set('date', day);
        // this.setState({ activeDay: [newDate.format('YYYY MM DD'), { day, month, year }] }, () => {
        this.props.currentCalendar?.setActiveDay(day)

        // this.setState({ activeDay: day }, () => {
        //     this.changeData()
        // })
    }

    changeData = () => {
        let showData = this.props.data
        let key = this.state.key
        if (showData) {
            showData = showData.filter(cdata => moment(cdata?.values[key]).format('YYYY-MM-DD') === this.state.activeDay?.key)
        }
        this.setState({ showData })
    }


    actionClicked = (prop, data, index) => {
        this.props.functionsHandler('collection', prop, data, index)
    }






    render() {
        const calender = this.props.currentCalendar;
        const week = calender?.getWeek();
        let data = []
        if (this.props.daysData && this.props.daysData[calender.activeDay?.key]) {
            data = this.props.daysData[calender.activeDay.key]
        }


        return (
            <div className='' style={{ direction: 'ltr' }}>

                <div style={{ background: '#fff', top: 0, }}>

                    <div className="" style={{ background: "#fff", borderBottom: '1px solid #f0f0f0' }}>
                        <div className="d-flex" style={{ justifyContent: 'space-between' }}>


                            {week?.map((day, index) => {

                                const isSelected = calender.activeDay?.key == day.key
                                const isToday = calender.today?.key == day.key

                                return (
                                    <div className='flex-1' style={{ padding: '2px 0px' }}>
                                        <button className='py-1 br-20' onDragOver={this.handleDragOver} onDrop={(event) => this.handleDrop(event, day)} onClick={() => this.selectDay(day)} style={{ alignItems: 'center', background: isSelected ? this.props.colors?.background : (isToday ? 'rgba(86, 84, 214,0.1)' : 'transparent'), width: '100%' }}>
                                            {/* {console.log(isSelected, "is today")} */}
                                            <div className='flexcc ' style={{ padding: 5 }}>

                                                <div className='mrd-1'>
                                                    <p className='text-normal text-semibold' style={{ color: isSelected ? this.props.colors?.textColor : '#000' }}>{checkTranslation(day.day)}</p>
                                                </div>
                                                <div className='' style={{ paddingTop: 2 }}>
                                                    <p className='text-smaller text-semibold ' style={{ color: isSelected ? this.props.colors?.textColor : '#000' }}>{checkTranslation(calender.weekDayNames[index])}</p>
                                                </div>

                                            </div>
                                        </button>
                                    </div>
                                )
                            })}


                        </div>
                    </div>
                </div>
                {/* <div className='w-100'>

                    {data?.length > 0 && (
                        <div className="h-100 w-100  " style={{ background: '#FFF' }}>


                            <TableViewer
                                headers={this.props.headers}
                                data={data}
                                actions={this.props.actions}
                                // actions={this.state.actions}
                                ref={el => this.TableViewer = el}
                            />


                        </div>
                    )}
                    {(data?.length == 0) && (
                        <div className='w-100 flexcc py-4'>
                            <p>{translate("No Data")}</p>
                        </div>
                    )}

                </div> */}

            </div >
        )
    }
}